import React, { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button, Popup } from '../../components';
import { POLICY_AGREEMENT } from '../../resources/enums';

export interface IntakeFormContentPopupProps {
  className?: string;
  form: POLICY_AGREEMENT;
  onClose(accept: boolean): void;
}

const agreementContents: Record<POLICY_AGREEMENT, string> = {
  [POLICY_AGREEMENT.DATA_PRIVACY_AGREEMENT]: '/assets/agreements/BackHealth_DataProtection.pdf',
  [POLICY_AGREEMENT.FEE_AGREEMENT_FOR_DOCTOR_CONSULTATION]: '/assets/agreements/FeeAgreement_DoctorConsultation.pdf',
  [POLICY_AGREEMENT.FEE_AGREEMENT_FOR_PHYSIOTHERAPY]: '/assets/agreements/FeeAgreement_PhysiotherapyServices.pdf',
  [POLICY_AGREEMENT.TREATMENT_AGREEMENT]: '/assets/agreements/BackHealth_Patients_ToC.pdf',
};

export const IntakeFormContentPopup: FC<IntakeFormContentPopupProps> = ({ className, form, onClose }) => {
  const { t } = useTranslation();

  return (
    <Popup contentClass={classNames('text-typo1 w-screen h-screen flex flex-col gap-4', className)} disableBackdrop>
      <h1>{t(`patientProfile.policyAgreements.${form}`)}</h1>
      <iframe
        className="w-full flex-1"
        src={agreementContents[form]}
        title={t(`patientProfile.policyAgreements.${form}`)}
      />
      <div className="flex justify-between gap-4">
        <Button className="max-sm:w-full" onClick={() => onClose(true)}>
          {t('common.accept')}
        </Button>
        <Button className="max-sm:w-full" variant="outline" onClick={() => onClose(false)}>
          {t('common.close')}
        </Button>
      </div>
    </Popup>
  );
};
